<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Add refund
      @if (order) {
        <p class="subtitle">Order #{{order.number}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="add()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading && order) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <h3>Items to refund</h3>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-grid class="ion-no-padding">
                  @for (item of refundable_items; track item) {
                    @if (item.refundable_quantity > 0) {
                      <ion-row class="quantity-row ion-align-items-start">
                        <ion-col>
                          <ion-grid class="ion-no-padding">
                            <ion-row>
                              <ion-col size="auto">
                                <h5>Item</h5>
                                <p class="prominent">{{item.title}}</p>
                              </ion-col>
                            </ion-row>
                            @if (item.sku) {
                              <ion-row>
                                <ion-col size="auto">
                                  <h5>SKU</h5>
                                  <p class="prominent">{{item.sku}}</p>
                                </ion-col>
                              </ion-row>
                            }
                          </ion-grid>
                        </ion-col>
                        <ion-col size="auto" class="ion-text-center">
                          <div>
                            <h5>Quantity@if (item.measurement_unit) {
                              ({{item.measurement_unit.symbol}})
                            }</h5>
                            <fa-icon size="lg" [icon]="['far', 'minus']" (click)="adjustItemQuantity(item.id,'subtract')"></fa-icon><span class="clickable-text" (click)="editItemQuantity(item)">{{item.quantity}} of {{item.refundable_quantity}}</span><fa-icon size="lg" [icon]="['far', 'plus']" (click)="adjustItemQuantity(item.id,'add')"></fa-icon>
                          </div>
                        </ion-col>
                      </ion-row>
                    }
                  }
                  @if (order.shipping && order.shipping.price > 0 && order.shipping.discount_rate < 100 && !shipping_refunded) {
                    <ion-row class="quantity-row ion-align-items-start">
                      <ion-col class="ion-align-self-center">
                        <ion-grid class="ion-no-padding">
                          <ion-row>
                            <ion-col size="auto">
                              <h5>Item</h5>
                              <p class="prominent">Shipping@if (order.shipping_rate) {
                                : {{order.shipping_rate.internal_name}}
                              }</p>
                            </ion-col>
                          </ion-row>
                        </ion-grid>
                      </ion-col>
                      <ion-col size="auto" class="ion-text-center">
                        <div>
                          <h5>Quantity</h5>
                          <fa-icon size="lg" [icon]="['far', 'minus']" (click)="adjustShippingQuantity('subtract')"></fa-icon><span>{{shipping_quantity}} of 1</span><fa-icon size="lg" [icon]="['far', 'plus']" (click)="adjustShippingQuantity('add')"></fa-icon>
                        </div>
                      </ion-col>
                    </ion-row>
                  }
                </ion-grid>
              </ion-col>
            </ion-row>
          </ion-grid>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <h3>Details</h3>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (params['date']) {
                  <ion-input class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" value={{formatted_date}} (click)="presentDateTimePickerModal()"></ion-input>
                }
                @if (!params['date']) {
                  <ion-input class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['reason']">
                  <div slot="label">Reason<ion-text class="optional">optional</ion-text></div>
                </ion-textarea>
              </ion-col>
            </ion-row>
            @if (xero_connected) {
              <ion-row>
                <ion-col>
                  <ion-item lines="none" class="ion-no-padding">
                    <ion-toggle class="form-toggle" alignment="start" label-placement="stacked" [(ngModel)]="params['add_xero_credit_note']">Add Xero credit note</ion-toggle>
                  </ion-item>
                </ion-col>
              </ion-row>
            }
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }
</ion-content>